var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterviewPopup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 166,
    viewBox: "0 0 190 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.851 92.4141L94.0004 108.729H73.8877L87.7384 92.4141H107.851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8691 64.666H67.5695V62.0422H90.8691V64.666Z",
    fill: "#D4CEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8691 92.748H67.5695V90.1243H90.8691V92.748Z",
    fill: "#D4CEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8691 120.832H67.5695V118.208H90.8691V120.832Z",
    fill: "#D4CEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.804 41.8516H118.589V95.3868H114.804V41.8516Z",
    fill: "url(#paint0_linear_13117_5610)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.441 41.8516H112.227V95.3868H108.441V41.8516Z",
    fill: "url(#paint1_linear_13117_5610)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.078 41.8516H105.863V95.3868H102.078V41.8516Z",
    fill: "url(#paint2_linear_13117_5610)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7158 41.8516H99.5009V95.3868H95.7158V41.8516Z",
    fill: "url(#paint3_linear_13117_5610)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M151.5 117H153.416V154.739H151.5V117Z",
    fill: "url(#paint4_linear_13117_5610)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 45.1797H140.773V47.1744H139.214V45.1797Z",
    fill: "url(#paint5_linear_13117_5610)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M123.747 45.1797H125.306V47.1744H123.747V45.1797Z",
    fill: "url(#paint6_linear_13117_5610)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 65.4453H140.773V67.44H139.214V65.4453Z",
    fill: "#BFB6FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M123.747 65.4453H125.306V67.44H123.747V65.4453Z",
    fill: "url(#paint7_linear_13117_5610)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M130.859 55.3145H132.418V57.3091H130.859V55.3145Z",
    fill: "url(#paint8_linear_13117_5610)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 83.4336H140.773V85.4283H139.214V83.4336Z",
    fill: "#BFB6FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.747 83.4336H125.306V85.4283H123.747V83.4336Z",
    fill: "url(#paint9_linear_13117_5610)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.859 73.3008H132.418V75.2955H130.859V73.3008Z",
    fill: "url(#paint10_linear_13117_5610)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 103.703H140.773V105.698H139.214V103.703Z",
    fill: "url(#paint11_linear_13117_5610)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.747 103.703H125.306V105.698H123.747V103.703Z",
    fill: "url(#paint12_linear_13117_5610)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M130.859 93.5703H132.418V95.565H130.859V93.5703Z",
    fill: "#BFB6FD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M143.392 113.836H144.95V115.831H143.392V113.836Z",
    fill: "url(#paint13_linear_13117_5610)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M139.214 123.969H140.773V125.963H139.214V123.969Z",
    fill: "#BFB6FD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.747 123.969H125.306V125.963H123.747V123.969Z",
    fill: "url(#paint14_linear_13117_5610)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.859 113.836H132.418V115.831H130.859V113.836Z",
    fill: "url(#paint15_linear_13117_5610)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2236 62.6875H69.22V133.668H65.2236V62.6875Z",
    fill: "url(#paint16_linear_13117_5610)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6572 62.6875H60.6536V133.668H56.6572V62.6875Z",
    fill: "url(#paint17_linear_13117_5610)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0908 62.6875H52.0872V133.668H48.0908V62.6875Z",
    fill: "url(#paint18_linear_13117_5610)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5244 62.6875H43.5208V133.668H39.5244V62.6875Z",
    fill: "url(#paint19_linear_13117_5610)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9561 62.6875H34.9524V133.668H30.9561V62.6875Z",
    fill: "url(#paint20_linear_13117_5610)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7402 86.7402H30.994V88.994H28.7402V86.7402Z",
    fill: "url(#paint21_linear_13117_5610)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7812 98.1875H37.035V100.441H34.7812V98.1875Z",
    fill: "#BFB6FD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1445 98.1875H59.3983V100.441H57.1445V98.1875Z",
    fill: "url(#paint22_linear_13117_5610)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8613 86.7402H49.1151V88.994H46.8613V86.7402Z",
    fill: "url(#paint23_linear_13117_5610)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7402 109.639H30.994V111.892H28.7402V109.639Z",
    fill: "url(#paint24_linear_13117_5610)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7812 121.088H37.035V123.342H34.7812V121.088Z",
    fill: "url(#paint25_linear_13117_5610)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1445 121.088H59.3983V123.342H57.1445V121.088Z",
    fill: "url(#paint26_linear_13117_5610)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8613 109.639H49.1151V111.892H46.8613V109.639Z",
    fill: "#BFB6FD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7402 132.539H30.994V134.793H28.7402V132.539Z",
    fill: "url(#paint27_linear_13117_5610)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7812 143.986H37.035V146.24H34.7812V143.986Z",
    fill: "#BFB6FD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1445 143.986H59.3983V146.24H57.1445V143.986Z",
    fill: "url(#paint28_linear_13117_5610)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8613 132.539H49.1151V134.793H46.8613V132.539Z",
    fill: "url(#paint29_linear_13117_5610)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9512 51.0586H63.9761V57.5445H34.9512V51.0586Z",
    fill: "url(#paint30_linear_13117_5610)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9254 122.53C36.0731 123.576 36.3302 124.644 36.7355 125.662C38.3627 124.162 40.2883 122.981 42.3812 122.171C40.329 123.69 38.7621 125.598 37.7544 127.687L37.7547 127.694C38.3482 128.628 39.0887 129.489 40.0068 130.213C42.0081 131.804 44.6244 132.593 47.1656 133.017C50.3969 133.555 53.951 133.48 56.224 131.672C59.0123 129.44 58.9003 125.503 59.709 122.159C60.5803 118.539 62.7548 115.298 65.8389 112.965C65.082 109.719 64.8529 106.511 65.1152 103.458C66.0633 106.135 67.3649 108.685 68.9413 111.031C71.6642 109.566 74.5592 108.216 75.6943 105.627C76.5042 103.784 76.2394 101.627 75.9621 99.5644C75.2962 94.6459 74.6308 89.7346 73.9649 84.816C73.7998 83.5698 73.5711 82.2094 72.5669 81.2444C70.8556 79.6045 67.975 79.9848 65.8652 80.7863C63.4679 81.6958 61.3193 82.9292 59.3627 84.3505C59.8648 86.2128 60.0494 88.0709 59.9214 89.8516C59.565 88.2555 58.9688 86.7113 58.1848 85.2592C55.4764 87.4084 53.1189 89.9319 50.9132 92.4865C49.8501 93.7182 48.7952 94.9506 47.7575 96.1913C50.6706 98.1826 53.2537 100.449 55.4351 102.882C52.2323 101.131 48.8742 99.8196 45.5277 98.9504C43.372 101.685 41.3538 104.508 39.6033 107.524C36.9783 112.055 35.1657 117.201 35.9254 122.53Z",
    fill: "url(#paint31_linear_13117_5610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97512 104.971C2.19811 105.669 2.49807 106.339 2.86945 106.97C4.68263 110.053 7.79933 112.145 11.0093 113.719C14.2242 115.288 17.6386 116.454 20.732 118.252C26.7961 121.794 31.3425 127.833 33.1255 134.616C33.2926 135.233 33.4334 135.857 33.5474 136.485C33.5474 136.485 34.3731 120.357 29.8209 112.718C27.5934 108.979 23.4428 106.63 19.2369 105.516C16.6839 104.842 13.9559 104.676 11.6127 103.458C8.83733 102.01 6.90156 99.0775 6.66056 95.957C5.68072 98.389 6.48371 101.75 8.47823 103.453C5.59207 103.121 3.3368 100.09 3.28477 97.1859C1.42809 99.3377 1.11398 102.303 1.97512 104.971Z",
    fill: "url(#paint32_linear_13117_5610)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.97559 104.971C2.19857 105.668 2.49853 106.339 2.86991 106.97C4.68309 110.052 7.7998 112.144 11.0098 113.719C14.2247 115.287 17.6391 116.453 20.7324 118.251C26.7966 121.794 31.343 127.832 33.126 134.615C33.203 134.093 33.2578 133.562 33.297 133.037C33.4342 131.032 33.2913 129.016 32.8573 127.062C32.4653 125.297 31.8465 123.588 30.9896 121.995C28.8218 117.962 25.238 114.718 21.0139 112.966C17.7234 111.597 14.1386 111.133 10.7033 110.179C7.37251 109.254 4.01093 107.734 1.97559 104.971Z",
    fill: "url(#paint33_linear_13117_5610)"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1557 33.3758C31.6382 34.5969 31.0457 35.9768 29.8319 36.4564C28.6107 36.9387 27.2278 36.3391 26.7455 35.1181C26.2631 33.8969 26.8657 32.5212 28.0869 32.0389C29.3007 31.5593 30.6734 32.1546 31.1557 33.3758Z",
    fill: "#2A2A2A"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3361 43.791L29.1923 44.2413C28.0435 44.6968 26.7428 44.135 26.2873 42.9862L21.0137 29.6354L26.3227 27.5352L31.5961 40.886C32.0469 42.0398 31.485 43.3353 30.3361 43.791Z",
    fill: "url(#paint34_linear_13117_5610)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2557 12.1129C52.2966 14.7235 51.025 17.6813 48.4144 18.7221L44.6465 9.27155C47.2571 8.23071 50.2149 9.50223 51.2557 12.1129Z",
    fill: "#D0D5DD"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9704 2.95312L49.5845 27.0673L30.8848 28.0322L25.7363 15.1188L39.9704 2.95312Z",
    fill: "#FF725E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6671 20.7441L18.314 32.3993C17.5276 32.352 16.7503 32.1632 16.0299 31.8536C14.3966 31.1467 13.0267 29.8168 12.3158 28.0336C11.2911 25.4637 11.9064 22.6467 13.6671 20.7441Z",
    fill: "url(#paint35_linear_13117_5610)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7647 15.0928L30.9803 28.1745C31.0362 28.3143 31.0639 28.4637 31.062 28.6141C31.0601 28.7646 31.0285 28.9132 30.9691 29.0515C30.9097 29.1898 30.8235 29.3149 30.7156 29.4199C30.6078 29.5248 30.4802 29.6074 30.3404 29.663L20.0891 33.7501C19.506 33.9826 18.8353 33.6988 18.6006 33.1102L13.385 20.0285C13.1503 19.4398 13.4419 18.7726 14.0249 18.5401L24.2762 14.453C24.416 14.3971 24.5653 14.3693 24.7158 14.3712C24.8663 14.3731 25.0149 14.4047 25.1532 14.4641C25.2914 14.5236 25.4166 14.6097 25.5216 14.7176C25.6265 14.8255 25.7091 14.953 25.7647 15.0928Z",
    fill: "#242424"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5934 1.26291L53.4294 25.9335C53.8378 26.9581 53.3398 28.1276 52.3096 28.5383C51.2794 28.949 50.1133 28.4431 49.7048 27.4185L39.8688 2.74792C39.771 2.5034 39.7224 2.24198 39.7257 1.97863C39.7291 1.71529 39.7844 1.4552 39.8884 1.21324C39.9924 0.971287 40.1431 0.752225 40.3319 0.568599C40.5207 0.384973 40.7439 0.240392 40.9886 0.143129C41.5036 -0.0622882 42.0514 -0.037922 42.5242 0.160768C42.9934 0.367083 43.388 0.74772 43.5934 1.26291Z",
    fill: "url(#paint36_linear_13117_5610)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M143.253 53.9883V141.678C143.253 145.37 140.265 148.359 136.572 148.359H6.68101C2.98887 148.359 0 145.37 0 141.678V53.9883H143.253Z",
    fill: "#2A2A2A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.253 53.9842V43.7552C143.253 40.0631 140.265 37.0742 136.572 37.0742H6.68101C2.98887 37.0742 0 40.0631 0 43.7552V53.9842H143.253Z",
    fill: "#1F1F1F"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3056 46.1843C20.3056 47.7121 19.0688 48.9487 17.541 48.9487C16.0132 48.9487 14.7764 47.7121 14.7764 46.1843C14.7764 44.6626 16.0131 43.4258 17.541 43.4258C19.0689 43.4258 20.3056 44.6625 20.3056 46.1843Z",
    fill: "url(#paint37_linear_13117_5610)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2646 46.1843C29.2646 47.7121 28.0277 48.9487 26.5 48.9487C24.9722 48.9487 23.7354 47.7121 23.7354 46.1843C23.7354 44.6626 24.972 43.4258 26.5 43.4258C28.0277 43.4258 29.2646 44.6625 29.2646 46.1843Z",
    fill: "url(#paint38_linear_13117_5610)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2245 46.1843C38.2245 47.7121 36.9877 48.9487 35.4599 48.9487C33.9322 48.9487 32.6953 47.7121 32.6953 46.1843C32.6953 44.6626 33.932 43.4258 35.4599 43.4258C36.9877 43.4258 38.2245 44.6625 38.2245 46.1843Z",
    fill: "url(#paint39_linear_13117_5610)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M125.712 48.9487C127.239 48.9487 128.476 47.7119 128.476 46.1902C128.476 44.6625 127.239 43.4258 125.712 43.4258H57.3074C55.7797 43.4258 54.543 44.6626 54.543 46.1843C54.543 47.7121 55.7797 48.9487 57.3074 48.9487H125.712Z",
    fill: "url(#paint40_linear_13117_5610)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2598 63.9531H128.993V100.183H14.2598V63.9531Z",
    fill: "url(#paint41_linear_13117_5610)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M94.542 110.15H128.992V134.798H94.542V110.15Z",
    fill: "#433D3D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2473 110.999C87.2473 111.466 86.8655 111.848 86.3986 111.848H15.1085C14.6417 111.848 14.2598 111.466 14.2598 110.999C14.2598 110.532 14.6417 110.15 15.1085 110.15H86.3986C86.8655 110.15 87.2473 110.532 87.2473 110.999Z",
    fill: "#433D3D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2473 118.65C87.2473 119.116 86.8655 119.498 86.3986 119.498H15.1085C14.6417 119.498 14.2598 119.116 14.2598 118.65C14.2598 118.183 14.6417 117.801 15.1085 117.801H86.3986C86.8655 117.801 87.2473 118.183 87.2473 118.65Z",
    fill: "#433D3D"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2473 126.3C87.2473 126.767 86.8655 127.149 86.3986 127.149H15.1085C14.6417 127.149 14.2598 126.767 14.2598 126.3C14.2598 125.833 14.6417 125.451 15.1085 125.451H86.3986C86.8655 125.451 87.2473 125.833 87.2473 126.3Z",
    fill: "#433D3D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2473 133.95C87.2473 134.417 86.8655 134.799 86.3986 134.799H15.1085C14.6417 134.799 14.2598 134.417 14.2598 133.95C14.2598 133.483 14.6417 133.102 15.1085 133.102H86.3986C86.8655 133.102 87.2473 133.483 87.2473 133.95Z",
    fill: "#433D3D"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1992 82.9728L68.0948 87.6726C67.4015 88.0763 66.5332 87.5811 66.5332 86.7738V77.3666C66.5332 76.5591 67.4015 76.0641 68.0948 76.4676L76.1992 81.1674C76.8923 81.5714 76.8923 82.5692 76.1992 82.9728Z",
    fill: "url(#paint42_linear_13117_5610)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M153.321 143.297C153.336 143.419 153.363 143.546 153.395 143.657L153.67 144.626L159.136 163.778C159.218 164.063 159.409 164.304 159.668 164.448C159.927 164.592 160.233 164.627 160.518 164.546C160.603 164.519 160.688 164.487 160.762 164.44C161.159 164.223 161.387 163.778 161.323 163.317L158.468 142.588C158.272 141.168 156.959 140.172 155.54 140.368C154.115 140.564 153.125 141.878 153.321 143.297Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M153.671 144.626L159.137 163.777C159.218 164.062 159.41 164.303 159.669 164.447C159.928 164.591 160.234 164.626 160.519 164.545C160.604 164.519 160.688 164.487 160.762 164.439L156.261 140.648C156.261 140.648 155.122 142.364 153.671 144.626Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M128.343 164.524C128.873 164.715 129.455 164.482 129.715 163.995L129.831 163.778L139.518 145.511C139.824 144.939 139.901 144.273 139.735 143.646C139.648 143.296 139.488 142.968 139.266 142.684C139.043 142.4 138.762 142.167 138.443 141.999C137.172 141.326 135.599 141.808 134.926 143.074C134.872 143.184 134.823 143.295 134.778 143.408L127.67 163.089C127.458 163.672 127.76 164.313 128.343 164.524Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M129.734 162.219C129.617 162.466 129.564 162.738 129.581 163.011C129.598 163.284 129.685 163.548 129.832 163.778L139.519 145.511C139.825 144.939 139.902 144.273 139.736 143.647L138.809 143.17L129.734 162.219Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M165.545 146.51L175.353 164.994C175.457 165.191 175.618 165.351 175.814 165.455C176.084 165.603 176.413 165.635 176.725 165.524C177.302 165.312 177.604 164.671 177.398 164.089L170.285 144.408C170.242 144.302 170.195 144.18 170.136 144.074C169.464 142.808 167.891 142.327 166.625 142.999C166.111 143.269 165.73 143.682 165.502 144.169C165.324 144.535 165.234 144.938 165.242 145.345C165.249 145.752 165.353 146.151 165.545 146.51Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M165.545 146.511L175.353 164.995C175.457 165.191 175.618 165.352 175.814 165.456C175.863 164.303 175.637 163.156 175.154 162.109L166.996 144.403L165.502 144.17C165.324 144.536 165.234 144.939 165.242 145.345C165.249 145.752 165.353 146.152 165.545 146.511Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.41 146.122C155.938 148.843 171.864 147.146 179.522 135.302C187.193 123.471 190.938 102.777 188.398 97.1532C187.828 95.8962 186.092 95.0022 183.656 94.3931C175.466 92.3328 159.476 93.3953 154.15 93.9267C147.256 94.6005 144.276 98.5269 142.747 102.35C141.218 106.185 136.617 113.079 132.704 115.126C128.842 117.148 126.562 119.389 125.512 124.262C125.499 124.34 125.473 124.417 125.461 124.495C124.437 129.51 128.868 143.388 142.41 146.122Z",
    fill: "#455A64"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M135.697 127.125C135.943 129.561 137.265 131.803 139.015 133.526C140.777 135.275 143.005 136.506 145.364 137.245C147.735 137.984 150.197 138.321 152.633 138.411C155.083 138.528 157.506 138.489 159.916 138.515C160.253 138.515 160.538 138.243 160.538 137.906C160.538 137.88 160.538 137.841 160.525 137.815V137.789C160.02 134.692 159.812 131.466 161.082 128.693C161.717 127.319 162.702 126.166 163.998 125.388C165.293 124.585 166.823 124.054 168.287 123.276C171.306 121.682 173.354 118.805 174.533 115.786C175.712 112.715 176.127 109.488 176.438 106.301C175.816 109.45 175.22 112.637 173.898 115.514C172.628 118.391 170.58 120.982 167.794 122.317C166.408 123.017 164.866 123.535 163.401 124.403C161.924 125.246 160.693 126.619 159.981 128.174C159.242 129.716 158.905 131.414 158.853 133.086C158.814 134.511 158.97 135.91 159.203 137.284C157.013 137.297 154.836 137.349 152.685 137.284C150.288 137.193 147.903 136.999 145.623 136.39C143.329 135.794 141.191 134.667 139.39 133.124C137.589 131.582 136.203 129.509 135.697 127.125Z",
    fill: "#455A64"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M142.41 146.124C155.938 148.845 171.864 147.147 179.522 135.304C187.193 123.473 190.938 102.778 188.398 97.1547C187.828 95.8976 186.092 95.0036 183.656 94.3945L183.695 94.4334C185.146 95.8718 186.144 97.7766 186.507 99.7852C187.193 103.621 186.04 107.534 184.835 111.24C183.034 116.812 181.064 122.358 178.149 127.425C175.233 132.492 171.294 137.105 166.253 140.059C158.426 144.634 148.28 144.737 140.181 140.681C133.456 137.325 128.221 131.274 125.512 124.263C125.499 124.341 125.473 124.419 125.461 124.496C124.437 129.511 128.868 143.389 142.41 146.124Z",
    fill: "#455A64"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M145.692 152.893V156.733L151.367 158.607V152.893H145.692Z",
    fill: "url(#paint43_linear_13117_5610)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M148.16 164.592V163.418L146.986 164.592H136.413C136.469 164.304 137.022 161.879 139.862 160.488C142.885 159.007 144.736 156.416 144.736 156.416L152.016 158.822C152.016 158.822 151.862 160.272 152.17 161.536C152.433 162.614 152.248 164.157 152.188 164.592H148.16Z",
    fill: "#FF725E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M152.286 163.592C152.266 163.926 152.233 164.259 152.188 164.591H148.16V163.592H152.286Z",
    fill: "url(#paint44_linear_13117_5610)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M147.985 163.592L146.986 164.591H136.413C136.433 164.487 136.521 164.103 136.754 163.592H147.985Z",
    fill: "url(#paint45_linear_13117_5610)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M143.433 157.224L144.986 158.777C145.096 158.887 145.28 158.887 145.393 158.775C145.446 158.721 145.476 158.648 145.476 158.572C145.476 158.497 145.446 158.424 145.393 158.37L143.84 156.817C143.786 156.764 143.714 156.734 143.638 156.734C143.562 156.734 143.489 156.764 143.435 156.817C143.323 156.93 143.323 157.114 143.433 157.224Z",
    fill: "url(#paint46_linear_13117_5610)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M142.482 158.176L144.034 159.728C144.145 159.839 144.329 159.839 144.442 159.726C144.495 159.672 144.524 159.599 144.524 159.524C144.524 159.448 144.495 159.375 144.442 159.321L142.889 157.768C142.835 157.715 142.762 157.686 142.687 157.686C142.611 157.686 142.538 157.715 142.484 157.768C142.372 157.881 142.372 158.065 142.482 158.176Z",
    fill: "url(#paint47_linear_13117_5610)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M141.531 159.127L143.083 160.679C143.194 160.79 143.378 160.79 143.49 160.677C143.544 160.623 143.573 160.55 143.573 160.475C143.573 160.399 143.544 160.326 143.49 160.272L141.938 158.72C141.884 158.666 141.811 158.637 141.735 158.637C141.66 158.637 141.587 158.666 141.533 158.72C141.42 158.832 141.42 159.016 141.531 159.127Z",
    fill: "url(#paint48_linear_13117_5610)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M117.809 153.143L116.921 156.732L122.595 158.606L124.007 153.143H117.809Z",
    fill: "url(#paint49_linear_13117_5610)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M119.388 164.592V163.418L118.215 164.592H107.642C107.698 164.304 108.251 161.879 111.091 160.488C114.114 159.007 115.965 156.416 115.965 156.416L123.244 158.822C123.244 158.822 123.09 160.272 123.399 161.536C123.661 162.614 123.477 164.157 123.416 164.592H119.388Z",
    fill: "#FF725E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M123.515 163.592C123.494 163.926 123.462 164.259 123.416 164.591H119.389V163.592H123.515Z",
    fill: "url(#paint50_linear_13117_5610)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M119.214 163.592L118.215 164.591H107.643C107.663 164.487 107.75 164.103 107.983 163.592H119.214Z",
    fill: "url(#paint51_linear_13117_5610)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M114.662 157.224L116.214 158.777C116.325 158.887 116.509 158.887 116.621 158.775C116.675 158.721 116.704 158.648 116.704 158.572C116.704 158.497 116.675 158.424 116.621 158.37L115.069 156.817C115.015 156.764 114.942 156.734 114.866 156.734C114.791 156.734 114.718 156.764 114.664 156.817C114.551 156.93 114.551 157.114 114.662 157.224Z",
    fill: "url(#paint52_linear_13117_5610)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M113.71 158.176L115.262 159.728C115.373 159.839 115.557 159.839 115.669 159.726C115.722 159.672 115.752 159.599 115.752 159.524C115.752 159.448 115.722 159.375 115.669 159.321L114.117 157.768C114.063 157.715 113.99 157.686 113.914 157.686C113.838 157.686 113.766 157.715 113.712 157.768C113.599 157.881 113.599 158.065 113.71 158.176Z",
    fill: "url(#paint53_linear_13117_5610)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M112.759 159.127L114.312 160.679C114.422 160.79 114.606 160.79 114.719 160.677C114.772 160.623 114.802 160.55 114.802 160.475C114.802 160.399 114.772 160.326 114.719 160.272L113.166 158.72C113.112 158.666 113.04 158.637 112.964 158.637C112.888 158.637 112.815 158.666 112.761 158.72C112.649 158.832 112.649 159.016 112.759 159.127Z",
    fill: "url(#paint54_linear_13117_5610)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.923 127.434L130.73 128.56L126.414 154.869L113.382 153.578C113.382 153.578 113.74 131.505 119.758 117.793C122.873 110.696 150.874 113.924 150.874 113.924L153.226 113.839C153.226 113.839 156.436 114.274 156.819 114.44C157.202 114.606 158.581 115.531 158.581 115.531L159.578 118.591C159.578 118.591 159.654 121.579 159.808 121.963",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M137.095 130.5C137.108 130.735 137.126 130.969 137.152 131.209C137.955 141.118 141.448 155.749 141.448 155.749L156.197 156.24L151.642 138.359L151.35 137.22L149.996 131.892C149.996 131.892 154.4 132.209 159 131.462C159.165 130.336 159.481 129.216 159.981 128.178C160.696 126.622 161.923 125.249 163.404 124.407C164.866 123.534 166.41 123.021 167.795 122.319C168.374 122.041 168.925 121.708 169.44 121.326C169.757 114.619 169.124 114.441 169.124 114.441L153.818 114.878C153.818 114.878 137.993 115.258 137.063 124.135C136.88 125.869 136.918 128.077 137.095 130.5Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M162.103 116.391C161.898 117 162.045 117.714 162.475 118.192C162.906 118.669 163.601 118.891 164.228 118.75",
    stroke: "#393E47",
    strokeWidth: 0.547,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M164.057 109.371C164.057 109.371 164.845 109.593 164.221 118.872C163.598 128.152 144.928 126.826 144.928 126.826L152.409 156.115",
    stroke: "#393E47",
    strokeWidth: 0.4786,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M143.134 105.719C143.134 105.719 143.701 108.424 146.361 110.992C149.685 114.207 156.282 117.21 169.124 114.441L168.867 112.507C168.867 112.507 169.632 112.183 170.636 111.584C172.639 110.392 175.599 108.109 175.311 105.162C174.881 100.735 171.445 93.2609 168.609 91.7562C167.925 91.3936 166.978 91.1027 165.936 90.8666C162.644 90.1273 158.385 89.9532 158.385 89.9532C158.385 89.9532 156.761 89.8554 154.855 90.0294C152.781 90.2202 150.372 90.7354 149.363 92.0565C147.431 94.5916 143.134 105.719 143.134 105.719Z",
    fill: "url(#paint55_linear_13117_5610)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146.36 110.991C149.685 114.206 156.281 117.209 169.124 114.44L168.866 112.506C168.866 112.506 169.632 112.181 170.636 111.583C170.252 111.376 169.856 111.185 169.463 111.004C167.273 109.997 164.993 109.141 162.62 108.726C161.242 108.485 159.833 108.397 158.437 108.511C157.858 108.559 155.48 108.611 156.179 109.785C156.444 110.228 157.264 110.457 157.712 110.667C158.325 110.954 158.947 111.221 159.577 111.468C160.828 111.958 162.108 112.368 163.41 112.697C164.876 113.069 166.367 113.336 167.872 113.493C164.147 114.576 160.059 114.359 156.47 112.89C154.106 111.922 151.922 110.419 149.403 109.992C148.387 109.821 147.195 109.897 146.548 110.698C146.476 110.789 146.413 110.887 146.36 110.991ZM165.599 99.3164L166.535 103.988C166.535 103.988 158.497 105.307 156.151 105.148C156.151 105.148 161.663 105.57 168.304 105.069C167.726 102.727 167.091 101.21 165.599 99.3164Z",
    fill: "black"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M168.304 106.068C167.908 103.894 166.918 101.831 165.469 100.162",
    stroke: "#D04242",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M155.416 85.7665C154.588 86.8969 154.292 87.8199 154.452 88.0107C154.619 88.2134 158.39 89.0862 158.39 89.0862L162.599 89.3962L163.789 88.0107L164.059 89.3962C164.059 89.3962 166.477 89.4559 166.713 89.0528C166.947 88.6498 163.825 83.5438 163.858 82.2344C163.892 80.9227 164.361 77.3288 160.095 76.4225C160.095 76.4225 157.677 75.8524 156.401 77.4313C156.401 77.4313 154.922 76.7589 154.116 78.6405C153.522 80.0261 154.576 80.701 155.175 81.1088L155.416 85.7665Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M154.855 90.0295L155.046 90.3061C156.053 91.7537 158.261 94.2412 160.145 94.3819C160.276 94.3914 160.407 94.3986 160.541 94.3986C162.757 94.3986 164.951 92.9939 165.881 90.9859L165.936 90.8666C162.644 90.1273 158.385 89.9531 158.385 89.9531C158.385 89.9531 156.761 89.8554 154.855 90.0295Z",
    fill: "#FF725E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M158.402 88.3166V88.3929L158.39 90.2817L158.386 90.9519C157.272 90.9018 155.517 90.9782 155.517 90.9782C155.517 90.9782 158.073 94.6509 160.189 94.8108C162.302 94.9706 164.472 93.6684 165.361 91.7438C163.771 91.4906 162.544 90.2119 162.354 88.6126C162.246 87.6981 162.156 86.6917 162.149 85.8293C162.419 85.6647 162.602 85.381 162.71 85.0829C162.857 84.6774 162.884 84.2147 162.7 83.8236C162.552 83.5135 162.254 83.2655 161.923 83.2058C161.982 82.7956 161.997 82.538 161.997 82.538C158.038 82.7096 156.414 79.8574 156.414 79.8574C155.333 80.1031 155.176 82.1088 155.176 82.1088C155.462 84.508 154.274 88.5862 157.987 88.3643C158.127 88.3572 158.265 88.3413 158.402 88.3166Z",
    fill: "url(#paint56_linear_13117_5610)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M158.147 83.862C158.147 84.0414 158.292 84.1864 158.472 84.1864C158.651 84.1864 158.796 84.0414 158.796 83.862C158.796 83.6824 158.651 83.5352 158.472 83.5352C158.292 83.5352 158.147 83.6826 158.147 83.862Z",
    fill: "url(#paint57_linear_13117_5610)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M159.223 83.4252L159.344 83.2201C158.994 83.0128 158.62 82.8491 158.231 82.7324L158.162 82.9609C158.533 83.0718 158.889 83.2278 159.223 83.4252Z",
    fill: "url(#paint58_linear_13117_5610)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M156.524 83.7916C156.524 83.971 156.379 84.1161 156.199 84.1161C156.02 84.1161 155.875 83.971 155.875 83.7916C155.875 83.6121 156.02 83.4648 156.199 83.4648C156.379 83.4648 156.524 83.6121 156.524 83.7916Z",
    fill: "url(#paint59_linear_13117_5610)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M155.515 82.9663C155.898 82.9093 156.286 82.8991 156.672 82.9361L156.695 82.6989C156.29 82.6598 155.882 82.6704 155.479 82.7304L155.515 82.9663Z",
    fill: "url(#paint60_linear_13117_5610)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M156.96 84.457C156.928 84.6418 156.907 84.8194 156.882 84.9954C156.86 85.1751 156.818 85.3313 156.812 85.5421C156.814 85.6448 156.839 85.7686 156.92 85.8652C157.003 85.9581 157.116 86.0102 157.228 86.0143C157.463 86.0292 157.646 85.8532 157.688 85.6731C157.557 85.806 157.386 85.8685 157.254 85.8299C157.112 85.7881 157.047 85.6912 157.05 85.5384C157.049 85.3871 157.083 85.1863 157.067 85.0033C157.058 84.8176 157.027 84.6325 156.96 84.457Z",
    fill: "url(#paint61_linear_13117_5610)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M158.064 86.3027C157.556 86.5932 156.895 86.5925 156.388 86.3008C156.437 86.5125 156.491 86.7305 156.593 86.9223C156.695 87.1141 156.857 87.2841 157.064 87.3485C157.327 87.4303 157.627 87.3234 157.814 87.1204C157.999 86.9175 158.068 86.5783 158.064 86.3027Z",
    fill: "url(#paint62_linear_13117_5610)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M149.076 98.2948C149.076 98.2948 141.065 97.7628 140.4 98.5607C139.735 99.3586 143.89 110.328 144.738 111.592C145.586 112.855 149.01 113.208 151.503 112.866C153.996 112.522 156.335 112.855 155.548 110.196C154.761 107.536 152.035 100.156 151.536 99.425C151.037 98.6937 150.535 98.5089 149.076 98.2948Z",
    fill: "url(#paint63_linear_13117_5610)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M147.36 104.438C147.36 104.438 146.577 105.251 148.495 105.786C148.495 105.786 147.708 106.415 148.903 106.825C150.1 107.233 150.288 106.856 151.295 107.359C152.301 107.863 152.301 108.113 154.281 108.962C154.604 109.1 154.929 109.233 155.256 109.36C155.671 108.166 155.788 106.351 155.816 105.125C155.571 105.08 155.39 105.025 155.277 104.958C153.839 104.109 154.061 103.665 152.327 103.15C150.594 102.632 147.584 102.108 148.087 103.334C148.087 103.334 146.446 103.432 147.36 104.438Z",
    fill: "url(#paint64_linear_13117_5610)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M152.907 94.5039C151.47 95.3852 150.378 96.8127 149.903 98.4299",
    stroke: "#D04242",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M143.517 103.636C143.759 103.634 143.885 103.303 143.779 103.085C143.672 102.867 143.431 102.752 143.201 102.674C142.608 102.471 141.977 102.402 141.353 102.471C140.99 102.512 140.604 102.617 140.375 102.903C140.101 103.246 140.136 103.738 140.219 104.17C140.353 104.866 140.581 105.561 141.015 106.121C141.448 106.682 142.114 107.094 142.823 107.094C143.214 107.094 143.606 107.072 143.987 106.983C144.14 106.948 144.305 106.891 144.381 106.754C144.434 106.658 144.43 106.537 144.384 106.437C144.339 106.338 144.351 106.313 144.255 106.259C144.434 106.301 144.599 106.122 144.664 105.977C144.74 105.81 144.813 105.629 144.741 105.46C144.668 105.291 144.496 105.17 144.313 105.159C144.502 105.138 144.677 105.05 144.807 104.911C144.936 104.772 145.005 104.576 144.977 104.39C144.934 104.105 144.679 103.889 144.403 103.806C144.127 103.723 143.804 103.612 143.517 103.636Z",
    fill: "url(#paint65_linear_13117_5610)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M143.586 103.647C143.072 103.568 142.551 103.553 142.033 103.604M144.347 105.147C143.692 105.064 143.033 105.024 142.372 105.027M144.287 106.266C143.7 106.205 143.111 106.176 142.521 106.179",
    stroke: "black",
    strokeWidth: 0.547,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M158.389 90.2817C159.04 90.1601 159.657 89.8381 160.115 89.3564C160.826 88.6147 161.119 87.4985 160.909 86.4922C160.318 87.3722 159.424 88.0448 158.415 88.3667L158.4 88.393L158.389 90.2817Z",
    fill: "#EC927D"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M155.256 110.362C158.091 111.469 164.662 113.644 173.009 113.863C173.009 113.863 178.447 113.477 174.514 102.516L170.326 105.959C170.326 105.959 158.735 106.682 155.816 106.126C155.788 107.352 155.671 109.167 155.256 110.362Z",
    fill: "url(#paint66_linear_13117_5610)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M156.44 78.4554C157.153 77.4427 158.382 76.8332 159.62 76.8112C160.858 76.7892 162.082 77.3337 162.946 78.2206C163.81 79.1074 164.317 80.3169 164.416 81.551C164.49 82.4685 164.351 83.4156 164.621 84.2958C165.084 85.812 166.621 86.7393 167.379 88.132",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M156.44 78.4554C157.153 77.4427 158.382 76.8332 159.62 76.8112C160.858 76.7892 162.082 77.3337 162.946 78.2206C163.81 79.1074 164.317 80.3169 164.416 81.551C164.49 82.4685 164.351 83.4157 164.621 84.2958C165.084 85.812 166.621 86.7393 167.379 88.132",
    stroke: "#263238",
    strokeWidth: 0.319,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M156.464 77.4147C155.689 77.1326 154.761 77.3365 154.176 77.9169C153.591 78.4972 153.38 79.4243 153.656 80.2007C153.837 80.7087 154.197 81.1294 154.474 81.5918C154.987 82.4462 155.219 83.4659 155.128 84.4581C155.036 85.4504 154.62 86.41 153.959 87.1557",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M156.464 77.4147C155.689 77.1326 154.761 77.3365 154.176 77.9169C153.591 78.4972 153.38 79.4243 153.656 80.2007C153.837 80.7087 154.197 81.1294 154.474 81.5918C154.987 82.4462 155.219 83.4659 155.128 84.4581C155.036 85.4504 154.62 86.41 153.959 87.1557",
    stroke: "#263238",
    strokeWidth: 0.319,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M161.872 83.7649C161.99 83.7129 162.134 83.7549 162.229 83.8427C162.323 83.9304 162.375 84.0559 162.403 84.1818C162.501 84.6235 162.323 85.1146 161.964 85.3912",
    stroke: "#865A50",
    strokeWidth: 0.547,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13117_5610",
    x1: 116.696,
    y1: 95.3868,
    x2: 116.696,
    y2: 41.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13117_5610",
    x1: 110.334,
    y1: 95.3868,
    x2: 110.334,
    y2: 41.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13117_5610",
    x1: 103.971,
    y1: 95.3868,
    x2: 103.971,
    y2: 41.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13117_5610",
    x1: 97.6084,
    y1: 95.3868,
    x2: 97.6084,
    y2: 41.8516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13117_5610",
    x1: 152.458,
    y1: 154.739,
    x2: 152.458,
    y2: 117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13117_5610",
    x1: 139.993,
    y1: 48.5085,
    x2: 139.993,
    y2: 44.9514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13117_5610",
    x1: 124.526,
    y1: 48.5085,
    x2: 124.526,
    y2: 44.9514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_13117_5610",
    x1: 124.526,
    y1: 68.7743,
    x2: 124.526,
    y2: 65.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_13117_5610",
    x1: 131.639,
    y1: 58.6433,
    x2: 131.639,
    y2: 55.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_13117_5610",
    x1: 124.526,
    y1: 86.7624,
    x2: 124.526,
    y2: 83.2053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_13117_5610",
    x1: 131.639,
    y1: 76.6296,
    x2: 131.639,
    y2: 73.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_13117_5610",
    x1: 139.993,
    y1: 107.032,
    x2: 139.993,
    y2: 103.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_13117_5610",
    x1: 124.526,
    y1: 107.032,
    x2: 124.526,
    y2: 103.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_13117_5610",
    x1: 144.171,
    y1: 117.165,
    x2: 144.171,
    y2: 113.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_13117_5610",
    x1: 124.526,
    y1: 127.298,
    x2: 124.526,
    y2: 123.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_13117_5610",
    x1: 131.639,
    y1: 117.165,
    x2: 131.639,
    y2: 113.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_13117_5610",
    x1: 67.2219,
    y1: 133.668,
    x2: 67.2219,
    y2: 62.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_13117_5610",
    x1: 58.6553,
    y1: 133.668,
    x2: 58.6553,
    y2: 62.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_13117_5610",
    x1: 50.0889,
    y1: 133.668,
    x2: 50.0889,
    y2: 62.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_13117_5610",
    x1: 41.5227,
    y1: 133.668,
    x2: 41.5227,
    y2: 62.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_13117_5610",
    x1: 32.9542,
    y1: 133.668,
    x2: 32.9542,
    y2: 62.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_13117_5610",
    x1: 29.867,
    y1: 90.5015,
    x2: 29.867,
    y2: 86.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_13117_5610",
    x1: 58.2713,
    y1: 101.949,
    x2: 58.2713,
    y2: 97.9295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_13117_5610",
    x1: 47.9883,
    y1: 90.5015,
    x2: 47.9883,
    y2: 86.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_13117_5610",
    x1: 29.867,
    y1: 113.4,
    x2: 29.867,
    y2: 109.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_13117_5610",
    x1: 35.9081,
    y1: 124.849,
    x2: 35.9081,
    y2: 120.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_13117_5610",
    x1: 58.2713,
    y1: 124.849,
    x2: 58.2713,
    y2: 120.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_13117_5610",
    x1: 29.867,
    y1: 136.3,
    x2: 29.867,
    y2: 132.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_13117_5610",
    x1: 58.2713,
    y1: 147.748,
    x2: 58.2713,
    y2: 143.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_13117_5610",
    x1: 47.9883,
    y1: 136.3,
    x2: 47.9883,
    y2: 132.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_13117_5610",
    x1: 49.4636,
    y1: 57.5444,
    x2: 49.4636,
    y2: 49.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_13117_5610",
    x1: 35.7511,
    y1: 106.704,
    x2: 76.2361,
    y2: 106.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_13117_5610",
    x1: 1.51854,
    y1: 116.221,
    x2: 33.606,
    y2: 116.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#D4CEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#E9E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_13117_5610",
    x1: 27.6226,
    y1: 106.667,
    x2: 10.7377,
    y2: 128.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#BFB6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#D3CDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954,
    stopColor: "#EAE7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_13117_5610",
    x1: 24.0607,
    y1: 37.3493,
    x2: 29.3711,
    y2: 35.2516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_13117_5610",
    x1: 12.315,
    y1: 28.0234,
    x2: 16.0119,
    y2: 26.5631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECBD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_13117_5610",
    x1: 44.7482,
    y1: 15.0916,
    x2: 48.5558,
    y2: 13.5876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECBD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_13117_5610",
    x1: 17.5411,
    y1: 48.9487,
    x2: 17.5411,
    y2: 43.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECBD0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79808"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_13117_5610",
    x1: 26.5,
    y1: 48.9487,
    x2: 26.5,
    y2: 43.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_13117_5610",
    x1: 35.4599,
    y1: 48.9487,
    x2: 35.4599,
    y2: 43.4258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0969DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_13117_5610",
    x1: 91.5095,
    y1: 43.4258,
    x2: 91.5095,
    y2: 48.9487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_13117_5610",
    x1: 71.626,
    y1: 100.183,
    x2: 71.626,
    y2: 63.9531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_13117_5610",
    x1: 65.3345,
    y1: 86.0095,
    x2: 73.2132,
    y2: 78.1309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_13117_5610",
    x1: 145.692,
    y1: 155.75,
    x2: 151.367,
    y2: 155.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#EC927D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_13117_5610",
    x1: 148.16,
    y1: 164.091,
    x2: 152.286,
    y2: 164.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_13117_5610",
    x1: 136.413,
    y1: 164.091,
    x2: 147.985,
    y2: 164.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_13117_5610",
    x1: 143.351,
    y1: 157.797,
    x2: 145.476,
    y2: 157.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_13117_5610",
    x1: 142.399,
    y1: 158.748,
    x2: 144.524,
    y2: 158.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_13117_5610",
    x1: 141.448,
    y1: 159.699,
    x2: 143.573,
    y2: 159.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_13117_5610",
    x1: 116.921,
    y1: 155.874,
    x2: 124.007,
    y2: 155.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#EC927D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_13117_5610",
    x1: 119.389,
    y1: 164.091,
    x2: 123.515,
    y2: 164.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_13117_5610",
    x1: 107.642,
    y1: 164.091,
    x2: 119.214,
    y2: 164.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_13117_5610",
    x1: 114.579,
    y1: 157.797,
    x2: 116.704,
    y2: 157.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_13117_5610",
    x1: 113.627,
    y1: 158.748,
    x2: 115.752,
    y2: 158.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_13117_5610",
    x1: 112.677,
    y1: 159.699,
    x2: 114.802,
    y2: 159.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18101E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#33253C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_13117_5610",
    x1: 174,
    y1: 102.001,
    x2: 141.5,
    y2: 102.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77953"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_13117_5610",
    x1: 165.361,
    y1: 87.3407,
    x2: 155.175,
    y2: 87.3407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#EC927D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_13117_5610",
    x1: 158.796,
    y1: 83.8608,
    x2: 158.147,
    y2: 83.8608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_13117_5610",
    x1: 159.344,
    y1: 83.0788,
    x2: 158.162,
    y2: 83.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_13117_5610",
    x1: 156.524,
    y1: 83.7905,
    x2: 155.875,
    y2: 83.7905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_13117_5610",
    x1: 156.695,
    y1: 82.821,
    x2: 155.479,
    y2: 82.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_13117_5610",
    x1: 157.687,
    y1: 85.2361,
    x2: 156.812,
    y2: 85.2361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_13117_5610",
    x1: 158.064,
    y1: 86.8385,
    x2: 156.387,
    y2: 86.8385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41262F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#543843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_13117_5610",
    x1: 145.787,
    y1: 98.7711,
    x2: 155.533,
    y2: 127.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_13117_5610",
    x1: 155.816,
    y1: 105.971,
    x2: 147.083,
    y2: 105.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#EC927D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_13117_5610",
    x1: 144.983,
    y1: 104.77,
    x2: 140.159,
    y2: 104.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#EC927D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BF9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_13117_5610",
    x1: 176,
    y1: 108,
    x2: 155,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9403E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F77953"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewPopup);
export default __webpack_public_path__ + "static/media/interview-popup.3c2826363e1d6f811a9b0ac2ff765351.svg";
export { ForwardRef as ReactComponent };